import { useAuth } from "../../hooks/authHook";
import { useLocation } from "react-router-dom";

export const useShouldShowLayout = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  return isAuthenticated && location.pathname !== "/signin";
};
